import {useCallback, useEffect, useState} from 'react';
import {useMountEffect} from 'webapp-lib/utils';

import {getStoredFavorites, setStoredFavorites} from '../timetracker.store';
import {DraggableWorkLogSuggestion} from '../types';

export const useFavorites = (): {
  favorites: DraggableWorkLogSuggestion[];
  onFavoriteDeleted: (deleted: DraggableWorkLogSuggestion) => void;
  onFavoriteUpdated: (edited: DraggableWorkLogSuggestion) => void;
} => {
  const [favorites, setFavorites] = useState<DraggableWorkLogSuggestion[]>([]);

  useMountEffect(() => {
    setFavorites(getStoredFavorites());
  });

  useEffect(() => {
    setStoredFavorites(favorites);
  }, [favorites]);

  const onFavoriteUpdated = useCallback(
    (edited: DraggableWorkLogSuggestion) => {
      setFavorites((prev) => {
        const exists = prev.find((item) => item.id === edited.id) !== undefined;
        if (exists) {
          return prev.map((item) => (item.id === edited.id ? edited : item));
        } else {
          return [...prev, edited];
        }
      });
    },
    []
  );

  const onFavoriteDeleted = useCallback(
    (deleted: DraggableWorkLogSuggestion) => {
      setFavorites((prev) => prev.filter((item) => item.id !== deleted.id));
    },
    []
  );

  return {favorites, onFavoriteUpdated, onFavoriteDeleted};
};
